module.exports = "/_next/static/images/Matthew_Franklin-0f1bcb624b85e54a8b8d9a3216832837.webp";